module.exports = "<md-dialog class=hq-table-dialog> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>MODEL_H_Q_TABLE</h2> <span flex></span> <md-button class=md-icon-button ng-click=$ctrl.cancelDialog()> <md-icon class=material-icons>close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content> <imomo-discharge-table discharge-model=$ctrl.dischargeModel min-x=$ctrl.minWaterLevel max-x=$ctrl.maxWaterLevel> </imomo-discharge-table> </div> </md-dialog-content> </md-dialog>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/station/creator/curve-hq-table.html
 ** module id = 234
 ** module chunks = 0
 **/